/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".item[_ngcontent-%COMP%]{height:120px;width:120px}.item-ask[_ngcontent-%COMP%]{position:relative;top:-2px}.item-description[_ngcontent-%COMP%]{padding:1rem;line-height:1.75;letter-spacing:.2px;font-size:12px}"];
export { styles as styles };
